export default __webpack_public_path__ + "static/media/adaptability.b9af241f.jpg";